import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDescription = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_27_6107)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M1.74219 7.99999C1.74219 5.01443 1.74219 3.52165 2.66968 2.59415C3.59718 1.66666 5.08996 1.66666 8.07553 1.66666C11.0611 1.66666 12.5539 1.66666 13.4814 2.59415C14.4089 3.52165 14.4089 5.01443 14.4089 7.99999C14.4089 10.9855 14.4089 12.4783 13.4814 13.4059C12.5539 14.3333 11.0611 14.3333 8.07553 14.3333C5.08996 14.3333 3.59718 14.3333 2.66968 13.4059C1.74219 12.4783 1.74219 10.9855 1.74219 7.99999Z",
			stroke: "#ADB5BD",
			strokeWidth: 1.5
		}), /* @__PURE__ */ _jsx("path", {
			d: "M4.74149 6.33332C4.58106 5.00334 5.35204 4.73124 8.07482 4.66666M8.07482 4.66666C10.8238 4.73371 11.6357 5.06552 11.4082 6.33332M8.07482 4.66666V11.3333M6.74149 11.3333H9.40816",
			stroke: "#ADB5BD",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_27_6107",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgDescription;
